/**
 * User: Rob/Shad
 * Date: 8/16/13
 */

"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var PaymentAuthorization = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

module.exports = root.bunsen.PaymentAuthorization = PaymentAuthorization;

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var transitionMixin = require('bunsen/models/mixins/ecomm/transitionMixin');
var endpoints = require('dibs-endpoints');
var Anchor = require('bunsen/models/Anchor');
var PaymentMethod = require('bunsen/models/ecomm/PaymentMethod');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var financialAmountMixin = require('bunsen/models/mixins/financialAmountMixin');
var PaymentProviderResponse = require('bunsen/models/ecomm/PaymentProviderResponse');
var Review = require('bunsen/models/ecomm/Review');

require('bunsen/libraries/plugins/jquery.payment');

_.extend(PaymentAuthorization, {
    STATUS_NEW: 'NEW',
    STATUS_AWAITING_FRAUD_SCORE: 'AWAITING_FRAUD_SCORE',
    STATUS_AWAITING_PROVIDER_RESPONSE: 'AWAITING_PROVIDER_RESPONSE',
    STATUS_PENDING_ADMIN_APPROVAL: 'PENDING_ADMIN_APPROVAL',
    STATUS_FRAUDULENT: 'FRAUDULENT',
    STATUS_AUTHORIZED: 'AUTHORIZED',
    STATUS_CAPTURED: 'CAPTURED',
    STATUS_DENIED_DATA_VALIDATION: 'DENIED_DATA_VALIDATION',
    STATUS_DENIED_PROCESSOR_ERROR: 'DENIED_PROCESSOR_ERROR',
    TIMEOUT_TRANSITION: 60000,
    PROGRESS_TRANSITION_ATTEMPTING: 'paymentAuthTransitionAttempting',
    PROGRESS_FETCHING: 'paymentAuthFetching',
    getActiveStatuses: function () {
        return [
            PaymentAuthorization.STATUS_PENDING_ADMIN_APPROVAL,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_AUTHORIZED,
            PaymentAuthorization.STATUS_CAPTURED
        ];
    },
    getTransitioningStatuses: function () {
        return [
            PaymentAuthorization.STATUS_AWAITING_PROVIDER_RESPONSE
        ];
    },
    getDeniedStatuses: function () {
        return [
            PaymentAuthorization.STATUS_DENIED_DATA_VALIDATION,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_DENIED_PROCESSOR_ERROR
        ];
    },
    newOfferPaymentAuthorization: function () {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_OFFER
            }
        });
    },
    newShipmentQuotePaymentAuthorization: function (shipmentQuote) {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_SHIPMENT_QUOTE,
                sourceId: shipmentQuote.id
            }
        });
    }
});

_.extend(PaymentAuthorization.prototype, {
    idAttribute: "id",
    initialize: function () {
        // set in here to work around backbone bug where url get set from parent
        this.url = function () {
            return endpoints.paymentAuthorization(this.get(this.idAttribute));
        };
    },
    relations : function () {
        return [
            {
                type: Backbone.One,
                key: 'paymentMethod',
                relatedModel: PaymentMethod,
                saveJSONFields : [
                    'apiType',
                    'id',
                    'token',
                    'nonce',
                    'cardHolderName',
                    'cardExpiryMonth',
                    'cardExpiryYear',
                    'maskedCardNumber',
                    'billingAddress',
                    'accountHolderName',
                    'confirmationNumber',
                    'transactionNumber',
                    'referenceNumber',
                    'paymentAuthorizationId'
                ]
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel: SoaModel,
                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: Anchor
            },
            {
                type: Backbone.Many,
                key: 'anchors',
                relatedModel: Anchor
            },
            {
                type: Backbone.One,
                key: 'amount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'authorizationAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'capturedAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.Many,
                key: 'paymentProviderResponses',
                relatedModel: PaymentProviderResponse
            },
            {
                type: Backbone.Many,
                key: 'reviews',
                relatedModel: Review
            }
        ];
    },
    /**
     * Return true if the transaction is "active", means it has already been processed
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */
    isActive: function () {
        return _.contains(PaymentAuthorization.getActiveStatuses(), this.get('status'));
    },
    isReadyForProcessing: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW;
    },
    isAuthorized: function () {
        return this.get('status') === PaymentAuthorization.STATUS_AUTHORIZED;
    },
    isCaptured: function () {
        return this.get('status') === PaymentAuthorization.STATUS_CAPTURED;
    },
    /**
     * Return true if the transaction is "current", meaning it is actively being
     * used for checkout or balance due. Status NEW or no ID
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */

    isCurrentCheckout: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW || this.isNew();
    },
    /**
     * Return true if the transaction is "current", for balance due
     * and linked to a shipmentQuote
     * @return {Boolean}
     */

    isCurrentBalanceDue: function () {
        return this.isNew();
    },
    /**
     * Returns true if the payment auth has been staged by ecom and is ready
     * to be posted to braintree
     * @returns {Boolean}
     */
    isStagedPaymentAuth: function () {
        return this.has('paymentProviderStagingArgument');
    },
    isDenied: function () {
        return _.contains(PaymentAuthorization.getDeniedStatuses(), this.get('status'));
    },
    isCheckoutPaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_OFFER;
    },
    isOfferPaymentAuthorization: function () {
        return this.isCheckoutPaymentAuthorization();
    },
    isBalanceDuePaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_SHIPMENT_QUOTE;
    },
    isShippingPaymentAuthorization: function () {
        return this.isBalanceDuePaymentAuthorization();
    },
    isWireTransfer: function () {
        return this.get('paymentMethod').isWireTransfer();
    },
    getBraintreeIdReserve: function () {
        return this.get('paymentProviderTransactionId');
    },
    getAmount: function (currency) {
        return this._getFinancialAmount('amount', currency);
    },
    getCapturedAmount: function (currency) {
        return this._getFinancialAmount('capturedAmount', currency);
    },
    getAuthorizationAmount: function (currency) {
        return this._getFinancialAmount('authorizationAmount', currency);
    },
    getCardType: function () {
        var paymentMethod = this.get('paymentMethod');
        var maskedCardNumber = paymentMethod && paymentMethod.get('maskedCardNumber');
        return maskedCardNumber && $.payment.cardType(maskedCardNumber);
    },
    autoCapture: function () {
        this.set('autoCapture', 'Y');
        return this.updateAndTransition(PaymentAuthorization.STATUS_CAPTURED);
    },
    hasAutoCaptureFailed: function () {
        var responses = this.get('paymentProviderResponses');
        if (!responses) {
            return false;
        }
        return responses.some(function (model) {
            return model.isVaultTransaction() && !model.isSuccess();
        });
    },
    hasPaymentDeclined: function() {
        return !!this.getPaymentReview();
    },
    getPaymentReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isPaymentDeclined();
        });
    },
    getFraudReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isFraud();
        });

    }
}, transitionMixin, financialAmountMixin);



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/PaymentAuthorization.js
// module id = 25
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54